import { maxBreakpoints, minBreakpoints } from '@noths/polaris-client-ribbons-design-system';
import { mediaQuery, pxToRem, theme } from '@noths/polaris-client-styles';
import { css } from 'styled-components';

const { spacing } = theme;

export const filterWrapper = css`
  ${mediaQuery(
    { max: maxBreakpoints.M },
    css`
      display: none;
    `,
  )}

  ${mediaQuery(
    { min: minBreakpoints.L },
    css`
      position: sticky;
      top: ${pxToRem(spacing.xl)};
    `,
  )};
`;
